/**
 * Nimizo × Shopify Forms — email + Subscribe row (blog newsletter look).
 * Hides #first_name and copies email into it on submit.
 * Uses border-box so full-width controls are not clipped by Forms overflow.
 */
(function () {
  var STYLE_ID = 'nimizo-forms-style';
  var FONT = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
  var CORAL = '#FF6B81';
  var MUTED = '#6B7280';

  var css = [
    ':host{',
    'display:block!important;width:100%!important;max-width:100%!important;',
    'font-family:' + FONT + '!important;',
    '--forms-body-font:normal 400 15px ' + FONT + '!important;',
    '--forms-base-font-size:15px!important;',
    '--body-text-color:#222!important;',
    '--form-text-color:#222!important;',
    '--form-placeholder-color:rgba(34,34,34,0.45)!important;',
    '--link-text-color:' + CORAL + '!important;',
    '--forms-accent-color:' + CORAL + '!important;',
    '--form-field-border:none!important;',
    '--form-field-border-focused:none!important;',
    '--form-field-border-radius:999px!important;',
    '--button-border-radius:999px!important;',
    '--button-background-color:' + CORAL + '!important;',
    '--button-text-color:#fff!important;',
    '--form-field-padding:0!important;',
    '--button-padding:0!important;',
    '--container-max-w:100%!important;',
    '--inline-container-max-width:100%!important;',
    '--forms-padding-top:0!important;',
    '--forms-padding-bottom:0!important;',
    '--forms-padding-left:0!important;',
    '--forms-padding-right:0!important;',
    '}',
    '*,*::before,*::after{box-sizing:border-box!important;}',
    'form,button,input,label,p,span,a{font-family:' + FONT + '!important;}',
    '[class*="formContainer"],[class*="formBody"],[class*="formContent"],[class*="inline"],[class*="gridItem"]{',
    'margin:0!important;padding:0!important;background:transparent!important;',
    'overflow:visible!important;max-width:100%!important;width:100%!important;',
    '}',
    '[class*="formFieldset"],form{',
    'display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;',
    'align-items:stretch!important;gap:0.6rem!important;',
    'margin:0!important;padding:0!important;',
    'width:100%!important;max-width:100%!important;overflow:visible!important;',
    '}',
    'label[class*="formInputFieldLabel"],[class*="formInputFieldLabel"]{',
    'display:none!important;',
    '}',
    /* Visible field wrappers (email) */
    '[class*="formFieldContainer"]{',
    'position:relative!important;',
    'height:48px!important;min-height:48px!important;max-height:48px!important;',
    'flex:1 1 200px!important;width:auto!important;min-width:200px!important;',
    'margin:0!important;padding:0!important;overflow:visible!important;',
    '}',
    /* Hide first name field + wrapper (after general container rules) */
    '#first_name,input#first_name,[class*="formFieldContainer"]:has(#first_name){',
    'position:absolute!important;width:1px!important;height:1px!important;',
    'padding:0!important;margin:-1px!important;overflow:hidden!important;',
    'clip:rect(0,0,0,0)!important;border:0!important;opacity:0!important;',
    'pointer-events:none!important;flex:0 0 0!important;min-width:0!important;',
    'min-height:0!important;max-height:0!important;',
    '}',
    /* Email field */
    '#email,input#email,input[inputmode="email"]{',
    'display:block!important;flex:1 1 200px!important;',
    'width:auto!important;min-width:200px!important;max-width:100%!important;',
    'min-height:48px!important;height:48px!important;',
    'margin:0!important;padding:0 1.1rem!important;',
    'border:1px solid rgba(34,34,34,0.1)!important;',
    'border-radius:999px!important;',
    'background:#fff!important;box-shadow:none!important;outline:none!important;',
    'appearance:none!important;-webkit-appearance:none!important;',
    '}',
    '#email:focus,input#email:focus,input[inputmode="email"]:focus{',
    'border-color:rgba(255,107,129,0.55)!important;',
    'box-shadow:0 0 0 3px rgba(255,107,129,0.15)!important;',
    '}',
    '#email::placeholder,input#email::placeholder,input[inputmode="email"]::placeholder{',
    'color:#9ca3af!important;opacity:1!important;',
    '}',
    'button[type="submit"],[data-testid="btn-form-submit"]{',
    'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
    'flex:0 0 auto!important;',
    'width:auto!important;min-width:8.5rem!important;max-width:100%!important;',
    'min-height:48px!important;height:48px!important;',
    'margin:0!important;padding:0 1.5rem!important;',
    'border:none!important;border-radius:999px!important;',
    'background:linear-gradient(135deg,#FF6B81 0%,#FF526C 100%)!important;',
    'color:#fff!important;font-size:0.98rem!important;font-weight:700!important;',
    'letter-spacing:-0.01em!important;',
    'box-shadow:0 6px 16px rgba(255,107,129,0.25)!important;',
    'overflow:visible!important;cursor:pointer!important;',
    'transition:transform .2s ease,background .2s ease,box-shadow .2s ease!important;',
    '}',
    'button[type="submit"]:hover,[data-testid="btn-form-submit"]:hover{',
    'background:linear-gradient(135deg,#E05368 0%,#D83B55 100%)!important;',
    'transform:translateY(-1px)!important;',
    'box-shadow:0 10px 20px rgba(255,107,129,0.3)!important;',
    '}',
    /* Hide legal disclaimer under the form */
    '[class*="formDisclaimer"],[class*="formDisclaimer"] p,[class*="formDisclaimer"] a{',
    'display:none!important;height:0!important;margin:0!important;padding:0!important;',
    'overflow:hidden!important;visibility:hidden!important;',
    '}',
    '@media (max-width:768px){',
    '[class*="formFieldset"],form{flex-direction:column!important;gap:0.55rem!important;}',
    '#email,input#email,input[inputmode="email"],button[type="submit"],[data-testid="btn-form-submit"]{',
    'width:100%!important;min-width:100%!important;',
    '}',
    '}'
  ].join('');

  function inject(root) {
    if (!root) return;
    var existing = root.getElementById(STYLE_ID);
    if (existing) {
      existing.textContent = css;
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    root.appendChild(style);
  }

  function ensureEmailPlaceholder(root) {
    var email = root.querySelector('#email, input[inputmode="email"]');
    if (!email) return;
    email.setAttribute('placeholder', 'Email address');
    if (!email.getAttribute('aria-label')) {
      email.setAttribute('aria-label', 'Email address');
    }
  }

  function wireNameFromEmail(root) {
    var form = root.querySelector('form');
    var email = root.querySelector('#email, input[inputmode="email"]');
    var firstName = root.querySelector('#first_name');
    if (!form || !email) return;

    ensureEmailPlaceholder(root);

    if (firstName) {
      var wrap = firstName.closest('[class*="formFieldContainer"]') || firstName.parentElement;
      if (wrap) {
        wrap.style.cssText =
          'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);margin:-1px;padding:0;border:0;opacity:0;pointer-events:none;flex:none;';
      }
    }

    if (root.__nimizoNameWired) return;
    root.__nimizoNameWired = true;

    function sync() {
      if (!firstName) return;
      firstName.value = (email.value || '').trim();
      firstName.dispatchEvent(new Event('input', { bubbles: true }));
    }

    email.addEventListener('input', sync);
    form.addEventListener('submit', sync, true);

    var btn = form.querySelector('button[type="submit"], [data-testid="btn-form-submit"]');
    if (btn && /submit/i.test((btn.textContent || '').trim())) {
      btn.textContent = 'Subscribe';
    }
  }

  function styleForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      if (!host.shadowRoot) return;
      inject(host.shadowRoot);
      wireNameFromEmail(host.shadowRoot);
    });
  }

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      styleForms();
    });
  }

  styleForms();
  document.addEventListener('DOMContentLoaded', styleForms);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
